import { z } from 'zod';
// Palette resserrée plutôt qu'un sélecteur de couleur libre (voir la conversation) : une teinte
// trop proche du fond ou du texte rendrait une branche illisible selon le thème actif (clair ou
// sombre, styles.css). Choisies pour rester distinctes et lisibles dans les deux.
export const BRANCH_COLOR_PALETTE = [
    '#e24329', // rouge
    '#fc6d26', // orange
    '#f0a500', // ambre
    '#2da44e', // vert
    '#1f78d1', // bleu
    '#6b4fbb', // violet
    '#d63384', // rose
    '#0d9488', // sarcelle
    '#8b5cf6', // indigo
    '#78716c', // gris chaud
];
// Un pattern est stocké tel quel (regex JS, sans délimiteurs `/.../`) — compilé à la volée par
// `new RegExp(pattern)` côté client (computeLayout.ts). Le .refine ci-dessous fait tourner ce
// même constructeur au moment de la validation Zod (donc aussi côté serveur, routes/repos.ts)
// pour ne jamais persister un pattern qui ne compile pas — partagé par toute l'équipe, une regex
// invalide écrite une fois casserait le graphe de tout le monde, pas juste de son auteur.
export const BranchColorRule = z.object({
    pattern: z.string().min(1).max(200).refine((p) => { try {
        new RegExp(p);
        return true;
    }
    catch {
        return false;
    } }, { message: 'Expression régulière invalide' }),
    color: z.enum(BRANCH_COLOR_PALETTE),
    // Requis : chaque règle nomme désormais aussi un groupe dans le filtre de branches de la
    // sidebar (BranchFilter.tsx) — voir le commentaire sur BranchColorRules ci-dessous pour la
    // sémantique complète. Une règle enregistrée avant l'ajout de ce champ (sans label) échoue
    // désormais la validation Zod ; elle doit être réenregistrée avec un nom (voir migration
    // manuelle : la règle `^main$` du repo Clearflow a été renommée "Main" à l'introduction de
    // cette contrainte).
    label: z.string().min(1).max(40),
});
// Partagées par dépôt (Repository.branchColorRules, pas User.preferences) : convention d'équipe,
// pas un réglage personnel. La première règle qui matche le nom de la branche gagne — l'ordre de
// la liste est la priorité, même principe qu'un .gitignore ou des overrides ESLint. N'évaluées
// qu'en amont de la palette par défaut (computeLayout.ts, branchColor()) : une branche qui ne
// matche aucune règle garde le comportement actuel, aucune régression pour un dépôt qui n'en
// définit aucune.
//
// Double rôle : chaque règle est aussi un groupe du filtre de branches (BranchFilter.tsx) — la
// première règle qui matche l'emporte, même ordre de priorité que pour la couleur, y compris pour
// `main`/`master` (une règle nommée "Main" sur `^main$` remplace le libellé par défaut
// "Principale"). Une branche qui ne matche aucune règle retombe sur le classement par préfixe
// historique (Feature/Fix/Chore/Release/Autre, "Principale" pour main/master) — même garantie de
// non-régression que ci-dessus, pour un dépôt qui n'a défini aucune règle couvrant cette branche.
// Le traitement spécial de main/master ailleurs dans l'appli (case à cocher non désactivable) ne
// dépend jamais du groupe où elle atterrit — voir isMainBranch dans BranchFilter.tsx.
export const BranchColorRules = z.array(BranchColorRule).max(50);
//# sourceMappingURL=branchColors.js.map